import React, { useEffect, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  InputGroupAddon,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
} from 'reactstrap';
import { logoutUser } from '../../actions/auth.js';
import { closeSidebar, openSidebar } from '../../actions/navigation.js';
import MenuIcon from '../Icons/HeaderIcons/MenuIcon.js';
import SearchBarIcon from '../Icons/HeaderIcons/SearchBarIcon.js';
import BellIcon from '../Icons/HeaderIcons/BellIcon.js';
import SearchIcon from '../Icons/HeaderIcons/SearchIcon.js';

import ProfileIcon from '../../assets/navbarMenus/pfofileIcons/ProfileIcon.js';
import MessagesIcon from '../../assets/navbarMenus/pfofileIcons/MessagesIcon.js';
import TasksIcon from '../../assets/navbarMenus/pfofileIcons/TasksIcon.js';

import logoutIcon from '../../assets/navbarMenus/pfofileIcons/logoutOutlined.svg';

import { searchMenuItems } from '../../config/menuSearch.js';

import s from './Header.module.scss';
import 'animate.css';

const Header = (props) => {
  const { history } = props;
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileSearchVisible, setMobileSearchVisible] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) setCurrentUser(u);
  }, []);

  const searchResults = searchMenuItems(searchQuery, currentUser?.peran);

  const handleClickOutside = useCallback(
    (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    },
    []
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    setSearchOpen(val.trim().length > 0);
  };

  const handleSearchSelect = (item) => {
    if (item.target === '_blank') {
      window.open(item.link, '_blank', 'noopener,noreferrer');
    } else {
      history.push(item.link);
    }
    setSearchQuery('');
    setSearchOpen(false);
    setMobileSearchVisible(false);
  };

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  };

  const doLogout = () => {
    props.dispatch(logoutUser());
  };

  const toggleSidebar = () => {
    if (props.sidebarOpened) {
      props.dispatch(closeSidebar());
    } else {
      props.dispatch(openSidebar());
    }
  };

  return (
    <Navbar className={`header-navbar ${s.headerMinimal} d-print-none`}>
      <div>
        <NavLink
          onClick={() => toggleSidebar()}
          className={`d-md-none mr-3`}
          href='#'
        >
          <MenuIcon className={s.menuIcon} />
        </NavLink>
      </div>
      <Form
        className={`${s.searchFormWrap} ${mobileSearchVisible ? s.searchMobileVisible : ''} ${mobileSearchVisible ? 'd-flex' : 'd-none d-sm-flex'}`}
        inline
      >
        <div ref={searchRef} className={s.searchFormGroup}>
          <InputGroup className={s.searchInputGroup}>
            <Input
              id='search-input'
              placeholder='Cari menu...'
              className='focus no-border'
              value={searchQuery}
              onChange={handleSearchChange}
              onFocus={() => searchQuery.trim() && setSearchOpen(true)}
              autoComplete='off'
            />
            <InputGroupAddon addonType='prepend'>
              <span className='d-flex align-self-center px-3'>
                <SearchBarIcon />
              </span>
            </InputGroupAddon>
          </InputGroup>
          {searchOpen && (
            <div className={s.searchDropdown}>
              {searchResults.length === 0 ? (
                <div className={s.searchDropdownEmpty}>Tidak ada hasil</div>
              ) : (
                <ul className={s.searchDropdownList}>
                  {searchResults.map((item, idx) => (
                    <li key={`${item.link}-${idx}`}>
                      <button
                        type='button'
                        className={s.searchDropdownItem}
                        onClick={() => handleSearchSelect(item)}
                      >
                        <span className={s.searchItemLabel}>{item.label}</span>
                        {item.parent && (
                          <span className={s.searchItemParent}>{item.parent}</span>
                        )}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </Form>
      <Nav className='ml-auto'>
        <NavItem className='d-sm-none mr-4'>
          <NavLink
            className=''
            href='#'
            onClick={(e) => {
              e.preventDefault();
              setMobileSearchVisible((v) => !v);
              setTimeout(() => document.getElementById('search-input')?.focus(), 50);
            }}
          >
            <SearchIcon />
          </NavLink>
        </NavItem>
        <NavItem className='mr-2 mr-sm-3'>
          <div className={s.navbarBlock} style={{ pointerEvents: 'none', cursor: 'default' }}>
            <BellIcon maskId={114} />
          </div>
        </NavItem>
        <Dropdown
          isOpen={notificationsOpen}
          toggle={() => toggleNotifications()}
          nav
          id='basic-nav-dropdown'
          className='ml-3'
        >
          <DropdownToggle nav caret className='navbar-dropdown-toggle'>
            <div className={`${s.avatar} rounded-circle float-left mr-2`}>
              <img
                src={
                  currentUser
                    ? currentUser.avatar
                      ? currentUser.avatar
                      : 'https://kalkulatorgizi.rotendaokab.go.id/foto/calorie.png'
                    : 'https://kalkulatorgizi.rotendaokab.go.id/foto/calorie.png'
                }
                alt='User'
              />
            </div>
            <span className={`small d-none d-sm-block ml-1 mr-2 ${s.userName}`}>
              {currentUser && currentUser.nama}
            </span>
          </DropdownToggle>
          <DropdownMenu
            className='navbar-dropdown profile-dropdown'
            style={{ width: '194px' }}
          >
            <DropdownItem className={s.dropdownProfileItem}>
              <Link to='/template/user/profile'>
                <ProfileIcon />
                <span>Profile</span>
              </Link>
            </DropdownItem>
            <DropdownItem className={s.dropdownProfileItem}>
              <TasksIcon />
              <span>Tasks</span>
            </DropdownItem>
            <DropdownItem className={s.dropdownProfileItem}>
              <MessagesIcon />
              <span>Messages</span>
            </DropdownItem>
            <NavItem>
              <NavLink onClick={() => doLogout()} href='#'>
                <button
                  className='btn btn-primary rounded-pill mx-auto logout-btn'
                  type='submit'
                >
                  <img src={logoutIcon} alt='Logout' />
                  <span className='ml-1'>Logout</span>
                </button>
              </NavLink>
            </NavItem>
          </DropdownMenu>
        </Dropdown>
      </Nav>
    </Navbar>
  );
};

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebarOpened: PropTypes.bool,
};

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
  };
}

export default withRouter(connect(mapStateToProps)(Header));
